import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { IFoCaAn } from '../../../models/response/thuc-don/IFoCaAn';
import { eFoCaAnActionTypeIds, IFoCaAnActionTypes } from '../../action-types/thuc-don/IFoCaAnActionTypes';
import { actions } from '../../actions/actionsWrapper';


export function* foCaAnSaga(): any {
    yield takeLatest(eFoCaAnActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eFoCaAnActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eFoCaAnActionTypeIds.DELETE_START, deleteWorker)


}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.caAn.select_all)
    if (res.is_success) {
        yield put(actions.thucDonWrapper.caAn.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.thucDonWrapper.caAn.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: IFoCaAnActionTypes): any {
    const payload: IFoCaAn = action.payload as IFoCaAn;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.thucDonWrapper.caAn.update, payload)
    } else {
        res = yield call(apiWrapper.thucDonWrapper.caAn.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.thucDonWrapper.caAn.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.thucDonWrapper.caAn.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: IFoCaAnActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.caAn.delete, payload)
    if (res.is_success) {
        yield put(actions.thucDonWrapper.caAn.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.thucDonWrapper.caAn.DELETE_ERROR(res.message ?? "Error"))
    }
}